import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AmbientProvider } from "./contexts/AmbientContext";
import Index from "./pages/Index";
import Login from "./pages/login/Login";
import Register from "./pages/login/Register";
import Pricing from "./pages/login/PricingPage";
import CustomerSupport from "./pages/CustomerSupport";
import Privacy from "./pages/Privacy";
import TermsOfUse from "./pages/TermsOfUse";
import HelpUs from "./pages/HelpUs";
import AboutUs from "./pages/AboutUs";

import PrivateRoute from "./components/PrivateRoute";
import Home from "./pages/Home";
import Book from "./pages/Book";
import Chapter from "./pages/Chapter";
import Search from "./pages/Search";
import List from "./pages/List";


import 'bootstrap/dist/css/bootstrap.css';
import './main.css';

function App() {
  
  return (
    <AuthProvider>
      <BrowserRouter>
        <LanguageProvider>
          <AmbientProvider>
            <Routes>
              <Route path="/index" element={<Index />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/customer_support" element={<CustomerSupport />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms_of_use" element={<TermsOfUse />} />
              <Route path="/help_us" element={<HelpUs />} />
              <Route path="/about_us" element={<AboutUs />} />
              <Route
                path="/home"
                element={
                  <PrivateRoute>
                    <Home />
                  </PrivateRoute>
                }
              />
              <Route
                path="/book"
                element={
                  <PrivateRoute>
                    <Book />
                  </PrivateRoute>
                }
              />
              <Route
                path="/search"
                element={
                  <PrivateRoute>
                    <Search />
                  </PrivateRoute>
                }
              />
              <Route
                path="/list"
                element={
                  <PrivateRoute>
                    <List />
                  </PrivateRoute>
                }
              />
              <Route
                path="/chapter"
                element={
                  <PrivateRoute>
                    <Chapter />
                  </PrivateRoute>
                }
              />
              <Route path="*" element={<Index />} />
            </Routes>
          </AmbientProvider>
        </LanguageProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
